import { useId } from "react";

interface Props {
    label?: string;
    eventChange: (value: boolean) => void;
    estado: boolean;
    _disable?: boolean;
}

export const BasicSwitch = ({ eventChange, label, estado, _disable }: Props) => {
    const uniqueId = useId();

    return (
        <div className="form-check form-switch form-switch-success m-2" >
            <input 
                className="form-check-input" 
                checked={estado} 
                disabled={_disable} 
                style={{ marginTop: '10px', fontSize: '16px' }} 
                type="checkbox" 
                role="switch" 
                id={uniqueId} 
                onChange={(e) => eventChange(e.target.checked)} 
            />
            {label && (
                <label 
                    className="form-check-label" 
                    style={{ paddingLeft: '5px' }} 
                    htmlFor={uniqueId}
                >
                    {label}
                </label>
            )}
        </div>
    );
};
